(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('roles', {
            parent: 'application',
            url: '/roles',
            data: {
                pageTitle: 'global.menu.roles'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/roles/roles.html',
                    controller: 'RolesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roles');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
